export const userconst = {
  token: 'scaffold_token',
  username: 'scaffold_username',
  authorization: 'scaffold_authorization',
  authenticated: 'scaffold_authenticated',
};
